export const DEVICE_TYPE_DESKTOP = "desktop"
export const DEVICE_TYPE_MOBILE = "mobile"
export const DEVICE_TYPE_TABLET = "tablet"